module.exports = __webpack_public_path__ + "static/media/04_Maf_NuestroEquipo_MaDeLosAngelesMolina.39aefcf7.jpg";